import { render, staticRenderFns } from "./Viewcertificate.vue?vue&type=template&id=6db6046e&scoped=true"
import script from "./Viewcertificate.vue?vue&type=script&lang=js"
export * from "./Viewcertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6046e",
  null
  
)

export default component.exports